import { render, staticRenderFns } from "./IconAttachments.vue?vue&type=template&id=6a6192da&"
import script from "./IconAttachments.vue?vue&type=script&lang=js&"
export * from "./IconAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6192da')) {
      api.createRecord('6a6192da', component.options)
    } else {
      api.reload('6a6192da', component.options)
    }
    module.hot.accept("./IconAttachments.vue?vue&type=template&id=6a6192da&", function () {
      api.rerender('6a6192da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconAttachments.vue"
export default component.exports